import { styled } from 'styled-components';
import About from './About';
import DropdownList from './DropdownList';
import { BREAKPOINTS } from '../../../styles/variables';

const TextBlock = ({ data }) => {
  const aboutData = data.About_the_performance;
  const dropdownData = data.More_Fields;

  return (
    <TextBlockWr>
      <About data={aboutData} />
      <DropdownList data={dropdownData} />
    </TextBlockWr>
  );
};

const TextBlockWr = styled.section`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 50px;

  margin-bottom: 50px;

  @media ${BREAKPOINTS.laptop} {
    gap: 3.47vw;
    margin-bottom: 3.47vw;
  }

  @media ${BREAKPOINTS.mobile} {
    grid-template-columns: repeat(1, 1fr);
    gap: 5.83vw;

    margin-bottom: 5.83vw;
  }
`;

export default TextBlock;
